import React from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
// @material-ui/icons
import Email from "@material-ui/icons/Email";
import LockOutlined from "@material-ui/icons/LockOutlined";
import Check from "@material-ui/icons/Check";
import { Redirect, Link } from "react-router-dom";
// redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
// core components
import * as actionCreators from "actions/auth";
import Footer from "components/FooterMainPage/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Danger from "components/Typography/Danger";

import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";

import image from "assets/img/bg7.jpg";

function mapStateToProps(state) {
    return {
        isAuthenticating: state.auth.isAuthenticating,
        statusText: state.auth.statusText,
        isAuthenticated: state.auth.isAuthenticated,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class LoginPage extends React.Component {
    constructor(props) {
        super(props);
        // we use this to make the card to appear after the page has been rendered
        const redirectRoute = /redirect_to=([^&]+)/g.exec(this.props.location.search);
        this._isMounted = false;
        this.state = {
            cardAnimaton: "cardHidden",
            username: "",
            password: "",
            redirectTo: redirectRoute ? redirectRoute[1] : redirectRoute,
            rememberMe: false,
        };
    }

    changeValue(e, type) {
        const value = e.target.value;
        const next_state = {};
        next_state[type] = value;
        this.setState(next_state)
    }

    _handleKeyPress(e){
        if (e.key === "Enter" ){
            this.login(e)
        }
    }

    _changeCheckerHandler(e, type) {
        this.setState((prevState) => ({
            ...prevState,
            [type]: !prevState[type],
        }))
    }

    login(e){
        e.preventDefault();
        this.state.username && this.state.password &&
        this.props.loginUser(this.state.username, this.state.password, this.state.rememberMe, this.state.redirectTo);
    }

    componentDidMount() {
        // we add a hidden class to the card and after 700 ms we delete it and the transition appears
        this._isMounted = true;
        setTimeout(
                function() {
                    this._isMounted &&
                    this.setState({ cardAnimaton: "" });
                }.bind(this), 700
        );
    }

    componentWillUnmount(){
        this._isMounted = false;
    }

    render() {
        const { classes, statusText, isAuthenticated } = this.props;
        return (
            isAuthenticated ?
                <Redirect to={this.state.redirectTo || "/"} push/> :
                <div onKeyPress={(e) => this._handleKeyPress(e)}>
                    <div
                        className={classes.pageHeader}
                        style={{
                            backgroundImage: "url(" + image + ")",
                            backgroundSize: "cover",
                            backgroundPosition: "top center"
                        }}
                    >
                        <div className={classes.container}>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={4}>
                                    <Card className={classes[this.state.cardAnimaton]}>
                                        <form className={classes.form}>
                                            <CardHeader color="info" className={classes.cardHeader}>
                                                <h3>Вход</h3>

                                            </CardHeader>
                                            <CardBody>

                                                { statusText &&
                                                    <Danger>{statusText}</Danger>
                                                }
                                                <CustomInput
                                                    labelText="Логин или email"
                                                    id="email"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        type: "email",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <Email className={classes.inputIconsColor} />
                                                            </InputAdornment>
                                                        ),
                                                        onChange:(e) => this.changeValue(e, "username")
                                                    }}
                                                />
                                                <CustomInput
                                                    labelText="Пароль"
                                                    id="pass"
                                                    formControlProps={{
                                                        fullWidth: true
                                                    }}
                                                    inputProps={{
                                                        type: "password",
                                                        endAdornment: (
                                                            <InputAdornment position="end">
                                                                <LockOutlined
                                                                    className={classes.inputIconsColor}
                                                                />
                                                            </InputAdornment>
                                                        ),
                                                        onChange:(e) => this.changeValue(e, "password")
                                                    }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={this.state.isActive}
                                                            checkedIcon={<Check className={classes.checkedIcon} />}
                                                            icon={<Check className={classes.uncheckedIcon} />}
                                                            classes={{ checked: classes.checked }}
                                                            onChange={(e) => this._changeCheckerHandler(e, "rememberMe")}
                                                        />
                                                    }
                                                    classes={{ label: classes.label }}
                                                    label="Запомнить пароль"
                                                />
                                                <div className={classes.forgetPass}>
                                                    <Link to="/reset_pass">
                                                        Забыли пароль?
                                                    </Link>
                                                </div>
                                            </CardBody>
                                            <CardFooter className={classes.cardFooter}>
                                                <Button simple color="info" size="lg" onClick={(e) => this.login(e)}>
                                                    Войти
                                                </Button>
                                            </CardFooter>
                                        </form>
                                    </Card>
                                </GridItem>
                            </GridContainer>
                        </div>
                        <Footer whiteFont />
                    </div>
                </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(loginPageStyle)(LoginPage));



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx